import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';

/**
 * گرفتن محتوای برتر و اخبار
 */
@Injectable({
  providedIn: 'root'
})
export class GetNewsPostService {
  constructor(private baseClient: BaseHttpClientService) { }

  call(professorId?, courseId?, page_num?, page_size?, IsNews?, IsTopContent?) {
    let res = this.baseClient.get<GetBlogPostContentResponseModel>(

      `/api/v1/blogpost/get_blogposts?professorId=${professorId}&courseId=${courseId}&page_num=${page_num}&page_size=${page_size}&IsNews=${IsNews}&IsTopContent=${IsTopContent}`
    );

    return res;
  }
}



export interface GetBlogPostContentResponseModel {
  items: [],
  count_all: number
}